import React from 'react';
import styles from './AccordionPreviewImage.module.scss';

export const AccordionPreviewImage = ({ src, alt = '' }: Props) => (
    <img crossOrigin='anonymous'
        className={styles.default}
        src={src} alt={alt}
        height={22} width={22} />
);

type Props = {
    src: string;
    alt?: string;
}
